import React from 'react';
import { FadeIn } from './FadeIn';
import { XCircle, CheckCircle2 } from 'lucide-react';
export const PainPoints = () => {
  return <section className="py-24 bg-white relative" data-id="element-147">
      <div className="max-w-5xl mx-auto px-6" data-id="element-148">
        <FadeIn className="text-center mb-16" data-id="element-149">
          <h2 className="text-3xl md:text-5xl mb-6" data-id="element-150">
            Quizás querés emprender... pero todos los negocios parecen{' '}
            <span className="italic text-accent-rose-deep" data-id="element-151">
              difíciles, caros o imposibles.
            </span>
          </h2>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-152">
          <FadeIn direction="up" delay={0.1} className="bg-cream rounded-3xl p-8 md:p-10 shadow-sm border border-nude" data-id="element-153">
            <h3 className="text-2xl mb-6 text-text-dark/60" data-id="element-154">
              Lo que sentís hoy:
            </h3>
            <ul className="space-y-4" data-id="element-155">
              {['Frustración por depender económicamente de otros.', 'Sentís que estás estancada y sin un propósito propio.', 'Ansiedad al ver a otras mujeres logrando sus metas.', 'Miedo a invertir mucho dinero y perderlo todo.', 'Creés que no tenés la creatividad necesaria.'].map((text, i) => <li key={i} className="flex items-start gap-3 text-text-brown/80" data-id="element-156">
                  <XCircle className="w-6 h-6 text-red-300 shrink-0 mt-0.5" data-id="element-157" />
                  <span className="leading-relaxed" data-id="element-158">{text}</span>
                </li>)}
            </ul>
          </FadeIn>

          <FadeIn direction="up" delay={0.2} className="bg-nude rounded-3xl p-8 md:p-10 shadow-soft border border-beige relative overflow-hidden" data-id="element-159">
            <div className="absolute top-0 right-0 w-32 h-32 bg-white/40 rounded-full blur-2xl -mr-10 -mt-10" data-id="element-160" />
            <h3 className="text-2xl mb-6 text-text-dark" data-id="element-161">
              Lo que vas a lograr:
            </h3>
            <ul className="space-y-4 relative z-10" data-id="element-162">
              {['Independencia económica creando desde tu casa.', 'Un negocio aesthetic que te llene de orgullo.', 'Vender por Instagram sin mostrar tu cara si no querés.', 'Empezar con muy baja inversión y materiales simples.', 'Un sistema paso a paso que no requiere experiencia previa.'].map((text, i) => <li key={i} className="flex items-start gap-3 text-text-dark" data-id="element-163">
                  <CheckCircle2 className="w-6 h-6 text-accent-rose-deep shrink-0 mt-0.5" data-id="element-164" />
                  <span className="leading-relaxed font-medium" data-id="element-165">{text}</span>
                </li>)}
            </ul>
          </FadeIn>
        </div>
      </div>
    </section>;
};